import { WidgetType } from 'types/widget.types';

import { REVERSE_AXIS_CHARTS } from './ChartSettingsAxis.config';
import type { AxisPropertyName as AxisPropertyNameType } from './ChartSettingsAxis.types';

/**
 * Which axis to be updated based on widget or chart type.
 *
 * @param axis Axis to be changed.
 * @param widgetType Current widget or chart type.
 * @returns 'xAxis' | 'yAxis'
 */
export const getAxisPropertyName = (axis: AxisPropertyNameType, widgetType: WidgetType): AxisPropertyNameType => {
  // Reverse or invert axis for bar chart
  if (REVERSE_AXIS_CHARTS.includes(widgetType)) {
    return axis === 'xAxis' ? 'yAxis' : 'xAxis';
  }

  return axis;
};
